import React, { Component } from 'react';

import {Cam, Text} from './shared/Icons';
import { FormattedMessage } from 'react-intl';

class Lobby extends Component {

  setLocale(lang) {
    if (window.localStorage) {
      window.localStorage.setItem('language', lang);
      window.location.reload();
    }
  }

  render() {
    const localeLogo = 'Logo_' + this.props.locale;

    return (
      <div className="lobby">
        <div className="lobby-overlay"></div>
        <div className="lobby-overlay-shadow"></div>
        <div className="lobby-content">
          <img className="logo" src={localeLogo + '.png'} />
          {this.props.appointment &&
            <div className="appointment">
              <FormattedMessage
                id='Client.Lobby.YourAppointment'
                defaultMessage='Ihr Termin' />
              <FormattedMessage
                id='Client.Lobby.TimeDate'
                defaultMessage='{date} um {time}'
                values={{
                  date: <span className="date">{this.props.appointment.toLocaleDateString('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit' })}</span>,
                  time: <span className="time">{this.props.appointment.toLocaleTimeString('de-DE', {hour: '2-digit', minute: '2-digit'})}</span>
                }} />
            </div>}
          {this.props.user &&
            <div>
              <div className="contact">
                <span>
                  <FormattedMessage
                    id='Client.Lobby.YourContact'
                    defaultMessage='Ihr Kontakt heute' />
                </span>
                <span className="name">{this.props.user.name}</span>
                <span className={"onlinestate" + (this.props.user.online ? " online" : " offline")}>
                  {this.props.user.online ? 
                    <FormattedMessage
                      id='Client.Lobby.Present'
                      defaultMessage='Anwesend' />
                    :
                    <FormattedMessage
                      id='Client.Lobby.Absent'
                      defaultMessage='Abwesend' />
                  }
                </span>
                {this.props.user.online &&
                  <div className={"actions " + (this.props.user.online ? '' : 'disabled')}>
                    <div className="call roundIcon" onClick={this.props.onCall}>
                      {/*<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                          <path d="M0 0h24v24H0z" fill="none"/>
                          <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>*/}
                      <Cam />
                      <span>
                        <FormattedMessage
                          id='Client.Lobby.StartVideoCall'
                          defaultMessage='Videoanruf starten' />
                      </span>
                    </div>
                    {this.props.user.datachannel &&
                      <div className={"text roundIcon" + (this.props.hasUnreadMessages ? ' iconIndicator': '')} onClick={this.props.onChat}>
                        <Text />
                        <span>
                          <FormattedMessage
                            id='Client.Lobby.Textchat'
                            defaultMessage='Textchat' />
                        </span>
                      </div>}
                  </div>}
                  <div className="info">
                    <FormattedMessage
                      id='Client.Lobby.DirectPhone'
                      defaultMessage='Direkte Telefonnummer bei Problemen: {phone}'
                      values={{
                        phone: <span><br/><a href={"tel:" + this.props.user.phone} style={{fontSize:'1.2em'}}>{this.props.user.phone}</a></span>
                      }} />
                  </div>
              </div>
              {this.props.user.online &&
                <span className="hint" style={{fontSize: '0.8em', display:'block', maxWidth:'80vw', margin:'auto', marginTop: '3vh', lineHeight: '1.2em', textTransform: 'none'}}>
                  <FormattedMessage
                    id='Client.Lobby.ConfidentialMsg'
                    defaultMessage='Ihre Daten werden vertraulich behandelt. Es findet keine Aufzeichnung der Gesprächsinhalte statt.'
                    />
                </span>
              }
            </div>
          }
          <div className="languageswitcher">
            <ul>
              <li onClick={() => this.setLocale('de')} className={this.props.locale === 'de' ? 'active' : ''} data-lang='de'>Deutsch</li>
              <li onClick={() => this.setLocale('fr')} className={this.props.locale === 'fr' ? 'active' : ''} data-lang='fr'>Français</li>
              <li onClick={() => this.setLocale('it')} className={this.props.locale === 'it' ? 'active' : ''} data-lang='it'>Italiano</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
};

export default Lobby;


// WEBPACK FOOTER //
// ./src/Lobby.js